const containerPDPMain = document.querySelector('.js-pdp-new-main')

if(containerPDPMain){
  const thumbs = new Swiper(".js-gallery-thumbs", {
    spaceBetween: 16,
    slidesPerView: "auto",
    freeMode: true,
    watchSlidesProgress: true,
    direction: "vertical"
  });

  const gallery = new Swiper(".js-gallery", {
    spaceBetween: 10,
    thumbs: {
      swiper: thumbs
    },
  });
}